import React, { SyntheticEvent } from "react";

type PropTypes = {
  src: string;
  alt: string;
  onLoad?: () => void;
  onError?: (e: SyntheticEvent<HTMLImageElement, Event>) => void;
  style?: React.CSSProperties;
  className?: string;
};

export const ImageWithRef: React.FC<PropTypes> = React.forwardRef<
  HTMLImageElement,
  PropTypes
>(({ src, alt, onLoad, onError, style, className, ...rest }, ref) => {
  const [isLoaded, setIsLoaded] = React.useState(false);

  const handleLoad = React.useCallback(() => {
    setIsLoaded(true);
    if (onLoad) onLoad();
  }, [onLoad]);

  const handleError = React.useCallback(
    (e: SyntheticEvent<HTMLImageElement, Event>) => {
      setIsLoaded(true);
      if (onError) onError(e);
    },
    [onError],
  );

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      ref={ref}
      src={src}
      alt={alt}
      onLoad={handleLoad}
      onError={handleError}
      style={{
        display: isLoaded ? "unset" : "none",
        ...style,
      }}
      className={className}
      {...rest}
    />
  );
});

ImageWithRef.displayName = "ImageWithRef";
